import { render, staticRenderFns } from "./Travelerdetails.vue?vue&type=template&id=12bf7a76&scoped=true"
import script from "./Travelerdetails.vue?vue&type=script&lang=js"
export * from "./Travelerdetails.vue?vue&type=script&lang=js"
import style0 from "./Travelerdetails.vue?vue&type=style&index=0&id=12bf7a76&prod&scoped=true&lang=css"
import style1 from "./Travelerdetails.vue?vue&type=style&index=1&id=12bf7a76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bf7a76",
  null
  
)

export default component.exports